module.exports = __webpack_public_path__ + "img/regitze.d3afb498.png";